var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-home"},[_c('div',{staticClass:"back-to-home-body"},[_c('router-link',{staticClass:"router-link",attrs:{"to":{name: 'home'}}},[_c('button',{staticClass:"back-to-home-body__button"},[_vm._v("Back to home")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ae9eed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/backtohome/BackToHome.vue
// module id = null
// module chunks = 